<template>
    <div class="delivery-data--row--header">
        {{ title }}
    </div>

    <div v-if="!address.id || updateAddress" class="form">
        <div class="form--box">
            <label class="form-label" :for="`firstname-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.firstname`]}">
                <h4 class="required">Meno</h4>
                <input class="form-input" type="text" :id="`firstname-${component_id}`" name="firstname" v-model="address.firstname" placeholder="">
                <div v-if="errors && errors[`${type}.firstname`]" class="form-error">
                    {{ errors[`${type}.firstname`][0] }}
                </div>
            </label>
        </div>

        <div class="form--box">
            <label class="form-label" :for="`lastname-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.lastname`]}">
                <h4 class="required">Priezvisko</h4>
                <input class="form-input" type="text" :id="`lastname-${component_id}`" name="lastname" v-model="address.lastname" placeholder="">
                <div v-if="errors && errors[`${type}.lastname`]" class="form-error">
                    {{ errors[`${type}.lastname`][0] }}
                </div>
            </label>
        </div>

        <div class="form--box box-flex box-span-2">
            <span class="btn btn-text-action-black" @click="address.add_company_data = !address.add_company_data">
                {{ !address.add_company_data ? 'Pridať firemné údaje' : 'Odobrať firemné údaje' }}
            </span>
        </div>

        <div v-if="address.add_company_data" class="form--box box-span-2">
            <label class="form-label" :for="`company-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.company`]}">
                <h4>Názov firmy</h4>
                <input class="form-input" type="text" :id="`company-${component_id}`" name="company" v-model="address.company" placeholder="">
                <div v-if="errors && errors[`${type}.company`]" class="form-error">
                    {{ errors[`${type}.company`][0] }}
                </div>
            </label>
        </div>

        <div v-if="address.add_company_data" class="form--box">
            <label class="form-label" :for="`ico-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.ico`]}">
                <h4>IČO</h4>
                <input class="form-input" type="number" :id="`ico-${component_id}`" name="business_id" v-model="address.ico" placeholder="">
                <div v-if="errors && errors[`${type}.ico`]" class="form-error">
                    {{ errors[`${type}.ico`][0] }}
                </div>
            </label>
        </div>

        <div v-if="address.add_company_data" class="form--box">
            <label class="form-label" :for="`dic-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.dic`]}">
                <h4>DIČ / IČ DPH</h4>
                <input class="form-input" type="text" :id="`dic-${component_id}`" name="vat_number" v-model="address.dic" placeholder="">
                <div v-if="errors && errors[`${type}.dic`]" class="form-error">
                    {{ errors[`${type}.dic`][0] }}
                </div>
            </label>
        </div>

        <div class="form--box">
            <label class="form-label" :for="`street-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.street`]}">
                <h4 class="required">Ulica a číslo</h4>
                <input class="form-input" type="text" :id="`street-${component_id}`" name="address1" v-model="address.street" placeholder="">
                <div v-if="errors && errors[`${type}.street`]" class="form-error">
                    {{ errors[`${type}.street`][0] }}
                </div>
            </label>
        </div>

        <div class="form--box">
            <label class="form-label" :for="`psc-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.psc`]}">
                <h4 class="required">PSČ</h4>
                <input class="form-input" type="text" :id="`psc-${component_id}`" name="postcode" v-model="address.psc" placeholder="">
                <div v-if="errors && errors[`${type}.psc`]" class="form-error">
                    {{ errors[`${type}.psc`][0] }}
                </div>
            </label>
        </div>

        <div class="form--box">
            <label class="form-label" :for="`city-${component_id}`" :class="{'form-label-error' : errors && errors[`${type}.city`]}">
                <h4 class="required">Mesto</h4>
                <input class="form-input" type="text" :id="`city-${component_id}`" name="city" v-model="address.city" placeholder="">
                <div v-if="errors && errors[`${type}.city`]" class="form-error">
                    {{ errors[`${type}.city`][0] }}
                </div>
            </label>
        </div>

        <div class="form--box">
            <div class="form-label">
                <h4 class="required">Štát</h4>
                <v-select :options="getCountries()" label="title" :reduce="item => item.id" v-model="address.country_id" :clearable="false"></v-select>
                <div v-if="errors && errors['delivery_address.country_id']" class="form-error">
                    {{ errors['delivery_address.country_id'][0] }}
                </div>
            </div>
        </div>

        <div class="form--box box-span-2">
            <div class="form-label" :class="{'form-label-error' : errors && errors[`${type}.phone_number`]}">
                <h4 class="required">Telefón</h4>

                <div class="form-label--grid">
                    <div class="form-label--grid--box">
                        <v-select :options="getPhonePrefixes()" label="title" :reduce="item => item.prefix" v-model="address.phone_prefix" :clearable="false"></v-select>
                    </div>

                    <div class="form-label--grid--box">
                        <input class="form-input" type="text" name="phone-number" v-model="address.phone_number" placeholder="900123456">
                    </div>
                </div>

                <div v-if="errors && errors[`${type}.phone_number`]" class="form-error">
                    {{ errors[`${type}.phone_number`][0] }}
                </div>
            </div>
        </div>
    </div>

    <div v-if="address.id && !updateAddress" class="address-wrapper">
        <div class="address-wrapper--row" :class="{ 'grid-row' : address.add_company_data }">
            <div class="address-wrapper--row--col">
                <ul>
                    <li><strong>{{ address.firstname + ' ' + address.lastname }}</strong></li>
                    <li>{{ address.street }},</li>
                    <li>{{ address.psc + ', ' + address.city + ', ' + country }}</li>
                    <li>Tel: {{ address.phone_prefix + ' ' + address.phone_number }}</li>
                </ul>
            </div>

            <div v-if="address.add_company_data" class="address-wrapper--row--col">
                <ul>
                    <li><strong>{{ address.company }}</strong></li>
                    <li>IČO: {{ address.ico }}</li>
                    <li>DIČ: {{ address.dic }}</li>
                </ul>
            </div>
        </div>

        <div class="address-wrapper--row">
            <span class="cta-change" @click="updateAddress = !updateAddress">Zmeniť</span>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    
    export default {
        components: {
            vSelect
        },
        emits: ['update'],
        props: {
            title: {
                type: String
            },
            errors: {
                type: Object
            },
            type: {
                type: String
            },
            data: {
                type: Object
            }
        },
        data() {
            return {
                address: {
                    firstname: null,
                    lastname: null,
                    add_company_data: false,
                    company: null,
                    ico: null,
                    dic: null,
                    street: null,
                    psc: null,
                    city: null,
                    country_id: 1,
                    phone_prefix: '+421',
                    phone_number: null
                },
                updateAddress: false
            }
        },
        computed: {
            component_id() {
                return Math.floor( Math.random() * (999 - 1 + 1)) + 1
            },
            country() {
                return this.address.country_id ? this.getCountries().find( country => country.id === this.address.country_id ).title : null
            }
        },
        created() {
            this.address = this.data ? this.data : this.address
            this.$emit('update', this.address)
        },
        watch: {
            'address': {
                handler: function () {
                    if ( this.timer ) {
                        clearTimeout( this.timer )
                        this.timer = null
                    }
                    
                    this.timer = setTimeout(() => {

                        this.$emit('update', this.address)

                    }, 500)
                },
                deep: true
            },
        }
    }
</script>